import { NgModule } from '@angular/core';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import {
  ConfigurationModule,
  NAMESPACE_MERCHANDISE_PRICES,
} from '@epicuro-next/platform/configuration';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MerchandisePricesEffects } from './effects/merchandise-prices.effects';
import { merchandisePricesFeatureKey } from './models/state';
import { reducer } from './reducers';

@NgModule({
  imports: [
    DataMerchandiseModule,
    EffectsModule.forFeature([MerchandisePricesEffects]),
    ConfigurationModule.forFeature(NAMESPACE_MERCHANDISE_PRICES),
    StoreModule.forFeature(merchandisePricesFeatureKey, reducer),
  ],
})
export class DeprecatedMerchandisePricesModule {}
